<template>
  <div>
    <template v-if="editable">
      <template v-if="question.content == null">
        <b-row>
          <b-col :cols=3>
            <b-form-input v-on:change="inputAnswer" placeholder="Enter your choice"></b-form-input>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-row>
          <b-col v-if="question.content" :cols=9>
            <div v-html="question.content" class="question__content"></div>
          </b-col>
          <b-col :cols=3>
            <b-form-input v-on:change="inputAnswer" placeholder="Enter your choice"></b-form-input>
          </b-col>
        </b-row>
      </template>
    </template>
    <template v-else>
      <template v-if="question.content == null">
        <b-row>
          <template v-for="answer in question.answers">
            <b-col :key="answer.id" :cols=2>
              <b-form-input :state="response.answer == answer.content" :value="response.answer" readonly></b-form-input>
            </b-col>
            <template v-if="response.answer != answer.content">
              <b-col :key="answer.id + '.answer'" :cols=2>
                <b-form-input :state="true" :value="answer.content" readonly></b-form-input>
              </b-col>
            </template>
          </template>
        </b-row>
      </template>
      <template v-else>
        <b-row>
          <b-col :cols=6>
            <div v-if="question.content" v-html="question.content" class="question__content"></div>
          </b-col>
          
          
          <template v-for="answer in question.answers">
            <b-col :key="answer.id" :cols=2>
              <b-form-input :state="response.answer == answer.text_answer" :value="response.answer" readonly></b-form-input>
            </b-col>
            <template v-if="response.answer != answer.text_answer">
              <b-col :key="answer.id + '.answer'" :cols=2>
                <b-form-input :state="true" :value="answer.text_answer" readonly></b-form-input>
              </b-col>
            </template>
          </template>
        </b-row>
      </template>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionReadingText',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false,
      answer: []
    }
  },
  methods: {
    inputAnswer(evt) {
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: evt
      })
    },
    selectAnswer(dataAnswer) {
      this.$emit('selectAnswer', dataAnswer)
    }
  }
}
</script>